import { useEffect, useState } from "react";
import styles from "./bookingdetailspopup.module.css";
import dayjs from "dayjs";
import { authData } from "../../../components/GetAuth";
import HoverZoomImage from "../../../components/HoverZoomImage";
import axios from "axios";
import { Link } from "react-router-dom";
import { EditOutlined, PrintOutlined, PhoneOutlined, EmailOutlined, Close } from "@mui/icons-material";
import download from "downloadjs";
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
export default function BookingDetailsPopup({ bookingId, viewStr, setViewModalOpen, setLoading }) {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [bookingData, setBookingData] = useState({});
  const [pickupPhones, setPickupPhones] = useState([]);
  const [receipientPhones, setReceipientPhones] = useState([]);

  useEffect(() => {
    const getDetails = () => {
      setLoading(true);
      axios(process.env.REACT_APP_API_URL + "v1/bookings/" + bookingId, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setLoading(false);
          let bookingDataTemp = response.data.data;
          setBookingData(bookingDataTemp);

          if (bookingDataTemp && bookingDataTemp?.pickup_details?.phone) {
            let pPhones = [];

            if (bookingDataTemp?.pickup_details?.alt_phones && bookingDataTemp?.pickup_details?.alt_phones?.length > 0) {
              pPhones = bookingDataTemp?.pickup_details?.alt_phones?.map(i => {
                return i;
              });
            }

            setPickupPhones([bookingDataTemp?.pickup_details?.phone].concat(pPhones));
          }

          if (bookingDataTemp && bookingDataTemp?.recipient_details?.phone) {
            let pPhones = [];

            if (bookingDataTemp?.recipient_details?.alt_phones && bookingDataTemp?.recipient_details?.alt_phones?.length > 0) {
              pPhones = bookingDataTemp?.recipient_details?.alt_phones?.map(i => {
                return i;
              });
            }

            setReceipientPhones([bookingDataTemp?.recipient_details?.phone].concat(pPhones));
          }
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
    getDetails();
  }, [API_TOKEN, bookingId]);

  const printBooking = (id) => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/bookings-item-pdf/" + id, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      setLoading(false);
      const content = response.headers["content-type"];
      download(response.data, "booking-" + id + ".pdf", content);
    }).catch((error) => {
      setLoading(false);
    });
  }

  const deliveryDriverNames = Array.from(
    new Set((bookingData?.products || []).map((p) => p?.delivery_driver?.name).filter(Boolean))
  );

  const deliveredCount = (bookingData?.products || []).filter((p) => parseInt(p?.is_deliverred) === 1).length;
  const totalCount = (bookingData?.products || []).length;
  const isPartiallyDelivered = deliveredCount > 0 && deliveredCount < totalCount;

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
      Order Information: #{viewStr}
      <IconButton onClick={(e) => setViewModalOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
    </DialogTitle>
    <DialogContent className={`${styles.PopupContent}`}>
      <div className={`${styles.BodyHWithIcon}`}>
        <p>Please find the details of order #{bookingData?.booking_id} below:</p>
        <div className={`${styles.BodyHeadIcon}`}>
          {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:update') > -1) && (parseInt(bookingData?.status) === 0 || parseInt(bookingData?.status) === 1 || parseInt(bookingData?.status) === 2 || parseInt(bookingData?.status) === 3 || parseInt(bookingData?.status) === 4 || parseInt(bookingData?.status) === 5 || parseInt(bookingData?.status) === 6) && (<Link to={"/booking/edit-booking/" + bookingData?.id} aria-label="Edit booking"><EditOutlined /></Link>)}
          <button onClick={(e) => printBooking(bookingData?.id)} aria-label="Print booking"><PrintOutlined /></button>
        </div>
      </div>

      <div className={`${styles.MondalBodyDeRow}`}>
        <div className={`${styles.ModalDeBigSec}`}>
          <p className={`${styles.StepBoxTitle2}`}>Customer Account Details</p>
          <ul className={`${styles.SummeryListSec}`}>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Customer ID:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.customer_id}</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Customer Name:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.name}</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Customer Mobile:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.phone}</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Customer Email:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.customer?.email}</p>
            </li>
          </ul>
        </div>
        <div className={`${styles.ModalDeBigSec}`}>
          <p className={`${styles.StepBoxTitle2}`}>Additional Info</p>
          <ul className={`${styles.SummeryListSec}`}>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Booking Taken by:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.created_user}</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Booking Last Edited by:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.edited_user}</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Booking in Container:</p>
              <p className={`${styles.SummeryHeadText}`}>-</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Items:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.no_of_items} Item(s)</p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Freight Option:</p>
              <p className={`${styles.SummeryHeadText} ${styles.FreightTag}`}>
                {bookingData?.freight_type === 'Air Freight' ? <FlightTakeoffIcon /> : <DirectionsBoatIcon />}
                {bookingData?.freight_type || 'Sea Freight'}
              </p>
            </li>
            <li>
              <p className={`${styles.SummeryHeadTitle}`}>Booking Picked by:</p>
              <p className={`${styles.SummeryHeadText}`}>{bookingData?.picked_driver?.name}</p>
            </li>
          </ul>
        </div>
      </div>

      <div className={`${styles.MondalBodyDeRow}`}>
        <div className={`${styles.ModalDeFullSec}`}>
          <p className={`${styles.StepBoxTitle2}`}>Pickup Photo(s)</p>
          <div className={`${styles.ImageRow}`}>
            {bookingData?.images?.map((img, index) => (
              <HoverZoomImage key={img?.id ?? index} src={img.image_url} alt="Pickup photo" className={styles.imgDiv} />
            ))}
          </div>
        </div>
      </div>

      <div className={`${styles.MondalBodyDeRow}`}>
        <div className={`${styles.ModalDeBigSec}`}>
          <p className={`${styles.Title}`}>Booking Note:</p>
          <p className={`${styles.Text}`}>{bookingData?.description}</p>
        </div>
      </div>

      {(bookingData?.status === -1 || bookingData?.status === "-1") && (<div className={`${styles.BookingNote}`}>
        <p className={`${styles.Title}`}>Cancel Note:</p>
        <p className={`${styles.Text}`}>{bookingData?.cancel_note}</p>
      </div>)}

      <div className={`${styles.MondalBodyDeRow2}`}>
        <p className={`${styles.FullTitle}`}>Collection and delivery details</p>
        <div className={`${styles.ModalDeBigSec}`}>
          <p className={`${styles.StepBoxTitle2}`}>Pickup Address</p>
          <p className={`${styles.PickName}`}>{bookingData?.pickup_details?.name}</p>
          <p className={`${styles.DetailsList}`}>{bookingData?.pickup_details?.address}</p>
          {bookingData?.pickup_details?.post_code && <p className={`${styles.DetailsList}`}>Post Code: {bookingData?.pickup_details?.post_code}</p>}
          <p className={`${styles.DetailsList}`}><EmailOutlined />{bookingData?.pickup_details?.email}</p>
          <p className={`${styles.DetailsList}`}><PhoneOutlined />{pickupPhones.join(', ')}</p>
        </div>
        <div className={`${styles.ModalDeBigSec}`}>
          <p className={`${styles.StepBoxTitle2}`}>Delivery Address</p>
          <p className={`${styles.PickName}`}>{bookingData?.recipient_details?.name}</p>
          <p className={`${styles.DetailsList}`}>{bookingData?.recipient_details?.address}</p>
          {bookingData?.recipient_details?.post_code && <p className={`${styles.DetailsList}`}>Post Code: {bookingData?.recipient_details?.post_code}</p>}
          {(bookingData?.recipient_details?.email && bookingData?.recipient_details?.email !== '') && <p className={`${styles.DetailsList}`}><EmailOutlined />{bookingData?.recipient_details?.email}</p>}
          <p className={`${styles.DetailsList}`}><PhoneOutlined />{receipientPhones.join(', ')}</p>
        </div>
      </div>

      <div className={`${styles.MondalBodyDeRow2}`}>
        <p className={`${styles.FullTitle}`}>Item details</p>
        <div className={`${styles.ModalDeFullSec}`}>
          <p className={`${styles.StepBoxTitle2}`}>Pickup Date: {dayjs(bookingData?.pickup_date).format("ddd MMM D, YYYY")}</p>
          <div className={`${styles.TableSec}`}>
            <table>
              <tbody>
                <tr>
                  <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Item ID</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Item</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Cost</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Status</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Container</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Delivery Driver</td>
                </tr>
                {bookingData?.products?.map((item, index) => {
                  return (<tr key={item?.item_id ?? index}>
                    <td className={`${styles.TableCon}`}>{item.item_id}</td>
                    <td className={`${styles.TableCon}`}>
                      {item.product_title}
                      {parseInt(item.is_dimension) === 1 && <>
                        <br />
                        <span style={{ fontSize: '11px' }}>Dimension: <strong>L:{item?.length}cm</strong> <strong>W:{item?.width}cm</strong> <strong>H:{item?.height}cm</strong></span>
                      </>}
                      {bookingData?.freight_type === 'Air Freight' && item?.weight && <>
                        <br />
                        <span style={{ fontSize: '11px' }}>Weight: <strong>{item.weight} kg</strong></span>
                      </>}
                    </td>
                    <td className={`${styles.TableCon}`}>
                      £{parseFloat(item.subtotal).toFixed(2)}
                      {parseFloat(item.discount) > 0 && <>
                        <br />
                        <span style={{ fontSize: '11px' }}>(-£{parseFloat(item.discount).toFixed(2)})</span>
                      </>}
                    </td>
                    <td className={`${styles.TableCon}`}>{item?.status_text !== "" ? item.status_text : bookingData?.status_text}</td>
                    <td className={`${styles.TableCon}`}>{item?.container_name}</td>
                    <td className={`${styles.TableCon}`}>{item?.delivery_driver?.name || '-'}</td>
                  </tr>);
                })}
              </tbody>
            </table>
          </div>
          <div className={`${styles.EstiAmmo}`}>
            <ul>
              <li>
                <p className={`${styles.EstiTitle}`}>Item Subtotal:</p>
                <p className={`${styles.EstiInput}`}>£{parseFloat(bookingData?.amount)?.toFixed(2)}</p>
              </li>
              {(bookingData?.discount_amount > 0 && bookingData?.discount_val > 0) && (<li>
                <p className={`${styles.EstiTitle}`}>Membership Discount({bookingData?.discount_val}%):</p>
                <p className={`${styles.EstiInput}`}>-£{parseFloat(bookingData?.discount_amount)?.toFixed(2)}</p>
              </li>)}
              {bookingData?.referral_discount > 0 && (<li>
                <p className={`${styles.EstiTitle}`}>Referral Discount:</p>
                <p className={`${styles.EstiInput}`}>-£{parseFloat(bookingData?.referral_discount)?.toFixed(2)}</p>
              </li>)}
              {(bookingData?.collection_charge > 0 || bookingData?.delivery_charge > 0) && (<li>
                <p className={`${styles.EstiTitle}`}>Item Total:</p>
                <p className={`${styles.EstiInput}`}>£{Math.max(0, parseFloat(bookingData?.amount || 0) - parseFloat(bookingData?.discount_amount || 0) - parseFloat(bookingData?.referral_discount || 0)).toFixed(2)}</p>
              </li>)}
              {bookingData?.collection_charge > 0 && (<li>
                <p className={`${styles.EstiTitle}`}>Collection Charge{bookingData?.collection_miles ? ` (${parseFloat(bookingData.collection_miles).toFixed(2)} mi)` : ""}:</p>
                <p className={`${styles.EstiInput}`}>£{parseFloat(bookingData?.collection_charge).toFixed(2)}</p>
              </li>)}
              {bookingData?.delivery_charge > 0 && (<li>
                <p className={`${styles.EstiTitle}`}>Delivery Charge{bookingData?.delivery_miles ? ` (${parseFloat(bookingData.delivery_miles).toFixed(2)} mi)` : ""}:</p>
                <p className={`${styles.EstiInput}`}>£{parseFloat(bookingData?.delivery_charge).toFixed(2)}</p>
              </li>)}
              <li>
                <p className={`${styles.EstiTitle}`}>Total VAT:</p>
                <p className={`${styles.EstiInput}`}>£0.00</p>
              </li>
              <li>
                <p className={`${styles.EstiTitle}`}>Insurance Charges:</p>
                <p className={`${styles.EstiInput}`}>£0.00</p>
              </li>

              <li>
                <p className={`${styles.EstiTitle}`}>Order Total:</p>
                <p className={`${styles.EstiInput}`}>£{parseFloat(bookingData?.total)?.toFixed(2)}</p>
              </li>
            </ul>
          </div>        </div>
      </div>

      <div className={`${styles.MondalBodyDeRow2}`}>
        <p className={`${styles.FullTitle}`}>Delivery Groups</p>
        <div className={`${styles.ModalDeFullSec}`}>
          {(!bookingData?.delivery_completions || bookingData.delivery_completions.length === 0) && (
            <p className={styles.Text}>No deliveries recorded yet.</p>
          )}

          {bookingData?.delivery_completions?.map((group) => (
            <div className={styles.DeliveryGroup} key={group.id}>
              <div className={styles.DeliveryGroupHead}>
                <div>
                  <p className={styles.DeliveryGroupDriver}>{group.driver?.name || 'Unknown driver'}</p>
                  <p className={styles.DeliveryGroupDate}>{dayjs(group.delivered_date).format("ddd MMM D, YYYY")}</p>
                </div>
                <span className={styles.DeliveryGroupCount}>{group.items?.length} item{group.items?.length > 1 ? 's' : ''}</span>
              </div>

              <div className={`${styles.TableSec}`}>
                <table>
                  <tbody>
                    <tr>
                      <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Item ID</td>
                      <td className={`${styles.TableHead} ${styles.TableHeadPrimary}`}>Item</td>
                    </tr>
                    {group.items?.map((item) => (
                      <tr key={item.id}>
                        <td className={`${styles.TableCon}`}>{item.item_id}</td>
                        <td className={`${styles.TableCon}`}>{item.product_title}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {group.delivery_note && (<div className={styles.DeliveryGroupNote}>
                <p className={styles.Title}>Delivery Note</p>
                <p className={styles.Text}>{group.delivery_note}</p>
              </div>)}

              {/* Proof of delivery: the photo beside the customer's signature */}
              {(group.delivery_image_url || group.customer_signature_url) && (<div className={styles.ProofRow}>
                <div>
                  <p className={styles.Title}>Delivery Photo</p>
                  {group.delivery_image_url
                    ? <HoverZoomImage src={group.delivery_image_url} alt={`Delivery photo from ${group.delivered_date}`} className={styles.ProofBox} />
                    : <div className={`${styles.ProofBox} ${styles.ProofEmpty}`}>No photo</div>}
                </div>
                <div>
                  <p className={styles.Title}>Customer Signature</p>
                  {group.customer_signature_url
                    ? <HoverZoomImage src={group.customer_signature_url} alt={`Signature captured on ${group.delivered_date}`} className={`${styles.ProofBox} ${styles.ProofSignature}`} contain />
                    : <div className={`${styles.ProofBox} ${styles.ProofEmpty}`}>Not signed</div>}
                </div>
              </div>)}
            </div>
          ))}
        </div>
      </div>

      {bookingData?.payments?.length > 0 && (<div className={`${styles.MondalBodyDeRow2}`}>
        <p className={`${styles.FullTitle}`}>Payment Details</p>
        <div className={`${styles.ModalDeFullSec}`}>
          <div className={`${styles.TableSec}`}>
            <table>
              <tbody>
                <tr>
                  <td className={`${styles.TableHead} ${styles.TableHeadAccent}`}>Paid Amount</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadAccent}`}>Payment Notes</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadAccent}`}>Created By</td>
                  <td className={`${styles.TableHead} ${styles.TableHeadAccent}`}>Created Date</td>
                </tr>
                {bookingData?.payments?.map((item, index) => {
                  return (<tr key={index}>
                    <td className={`${styles.TableCon}`}>£{parseFloat(item.amount).toFixed(2)}</td>
                    <td className={`${styles.TableCon}`}>{item.note}</td>
                    <td className={`${styles.TableCon}`}>{item.name}</td>
                    <td className={`${styles.TableCon}`}>{dayjs(item.created_at).format("DD/MM/YYYY LT")}</td>
                  </tr>);
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>)}
    </DialogContent>
  </>);
}